import { createAction } from "redux-actions";
import { createRequestActionTypes } from "../../../common/saga/createRequestSaga";

export const [UPDATE_USER, UPDATE_USER_SUCCESS, UPDATE_USER_FAILURE] = createRequestActionTypes(
  "updateUser/UPDATE_USER"
);

export const updateUserAction = createAction(UPDATE_USER, ({ oldPassword, password }) => ({
  oldPassword, password
}));

export const UPDATE_USER_INIT = "UPDATE_USER_INIT";

// 회원정보 조회 (본인)
export const [
  MY_INFO,
  MY_INFO_SUCCESS,
  MY_INFO_FAILURE
] = createRequestActionTypes("updateUser/MY_INFO");

export const myInfoAction = createAction(MY_INFO);

// 주소 갱신
export const [
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  UPDATE_ADDRESS_INIT
] = createRequestActionTypes("updateUser/UPDATE_ADDRESS");

export const updateAddressAction = createAction(
  UPDATE_ADDRESS,
  ({ address }) => ({ address })
);
export const updateAddressInit = createAction(UPDATE_ADDRESS_INIT);
